import { PricePlanTypeEnum } from '@systemeio/types'

export const pricePlanTypeLocoKeys: Record<PricePlanTypeEnum, string> = {
  [PricePlanTypeEnum.one_shot]: 'dashboard.funnel.price_plan.one_shot',
  [PricePlanTypeEnum.limited_subscription]: 'dashboard.funnel.price_plan.limited_subscription',
  [PricePlanTypeEnum.subscription]: 'dashboard.funnel.price_plan.subscription',
}
